module.exports = __webpack_public_path__ + "img/sacco5.ed32e503.png";